import { useMemo } from "react";
import { IVerifiedDomain } from "@evennt-tech/api-v2-core";
import { useAdminVerifiedDomains } from "./useAdminVerifiedDomains";

const FETCH_ALL_DOMAINS_LIMIT = 1000;

export const getPendingVerifiedDomains = (domains: IVerifiedDomain[]) =>
  domains.filter((domain) => domain.isApproved === null);

export const getPendingVerifiedDomainsCount = (domains: IVerifiedDomain[]) =>
  getPendingVerifiedDomains(domains).length;

export const useAdminPendingVerifiedDomainsCount = () => {
  const { items } = useAdminVerifiedDomains({
    page: 1,
    limit: FETCH_ALL_DOMAINS_LIMIT,
  });

  return useMemo(() => getPendingVerifiedDomainsCount(items), [items]);
};
